import { AssignmentRuleDTO } from '@user/store/leadAssignmentRule'
import { useEffect, useState } from 'react'

export function useData(assignmentRules: AssignmentRuleDTO[]) {
  const [assignmentRulesReOrderTemp, setAssignmentRulesReOrderTemp] = useState<
    AssignmentRuleDTO[]
  >([])

  useEffect(() => {
    setAssignmentRulesReOrderTemp(assignmentRules)
  }, [assignmentRules])

  return {
    assignmentRulesReOrderTemp,
    setAssignmentRulesReOrderTemp,
  } as const
}
